/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerBrands200,
  GetApiV1BannerBrands401,
  GetApiV1BannerBrands500,
  GetApiV1BannerBrandsQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1BannerBrands.ts";
import { brandDropDownViewModelSchema } from "../brandDropDownViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerBrands200Schema = z.array(
  z.lazy(() => brandDropDownViewModelSchema),
) as unknown as ToZod<GetApiV1BannerBrands200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerBrands401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBrands401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerBrands500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBrands500>;

export const getApiV1BannerBrandsQueryResponseSchema = z.lazy(
  () => getApiV1BannerBrands200Schema,
) as unknown as ToZod<GetApiV1BannerBrandsQueryResponse>;
